module.exports = __webpack_public_path__ + "d5d60d7f9b8334f4eae42beff31a1994.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_share.svg
// module id = qSyn
// module chunks = 5